module.exports = __webpack_public_path__ + "img/logo-iph-sistemas-instituto-pro-hemoce.847840ef.png";